/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-const */
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  Row,
  Col,
  Tooltip,
  Input,
  Button,
  Icons,
  Typography,
} from '~/components';
import { TIPO_VISAO } from '~/modules/Helper/tipo-visao';
import { TIPO_COLUNA } from '~/modules/Helper/tipoColuna';
import { obterAnoAtual } from '~/modules/Helper/DateTimeHelper';
import { AA_DISABLED_BORDER } from '~/modules/Helper/contrast.helper';
import Popover from '~/components/Popover/Popover.component';
import * as S from './FiltroPeriodicidadeModuloDinamico.styled';

const { Text, Link } = Typography;

/** Select nativo — evita aria-required-attr / aria-valid-attr-value do Antd 4 (WCAG-007). */
const nativeSelectStyle = {
  width: '100%',
  minHeight: 32,
  borderRadius: 2,
  border: `1px solid ${AA_DISABLED_BORDER}`,
  color: '#000',
  padding: '4px 8px',
  background: '#fff',
};

function FiltroPeriodicidadeModuloDinamico({
  filtro,
  pagina,
  setPagina,
  configuracao,
  listaColunaOrdem = [],
  removerColunaOrdenacao,
  obterColunaChave,
  obterColunaLink,
  setFiltro,
  InputCarregando,
  periodicidadeSelecionada,
  setPeriocidadeSelecionada,
  listaPeriodicidades,
  periodoDesabilitado,
  periodoSelecionado,
  setPeriodoSelecionado,
  listaPeriodos,
  exercicioSelecionado,
  setExercicioSelecionado,
  listaExercicios,
  isFiltroAvancadoHabilitado,
  history,
  obterOrdenacaoPadrao,
  setDataFilterHeader,
  dataFilterHeader
}) {
  const isDesktop = useMediaQuery({ query: '(min-width: 1201px)' });

  // TODO (remover): este filtro simples acima da grid deve ser excluído futuramente.
  // Por enquanto, precisamos apenas ocultar o componente (não remover) por demanda do negócio.
  const EXIBIR_FILTRO_SIMPLES_ACIMA_GRID = false;

  const tiposValorString = [
    TIPO_COLUNA.TEXTO_50,
    TIPO_COLUNA.TEXTO_100,
    TIPO_COLUNA.LINK,
    TIPO_COLUNA.BOOLEANO,
  ];

  const tiposValorData = [TIPO_COLUNA.DATA];

  const tiposValorNumber = [TIPO_COLUNA.INTEIRO, TIPO_COLUNA.DECIMAL];

  function verificaTipoInputEPlaceholder() {
    let inputType = 'text';
    let textoPlaceholder = 'Filtro';
    if (configuracao && configuracao.VisaoColunas) {
      const visaoColuna =
        configuracao.Tipo === TIPO_VISAO.AGRUPAMENTO
          ? obterColunaChave()
          : obterColunaLink();

      if (visaoColuna) {
        const { TipoValor, NomeColuna } = visaoColuna;
        
        if (TipoValor) {
          if (tiposValorString.includes(TipoValor)) {
            inputType = 'text';
          } else if (tiposValorNumber.includes(TipoValor)) {
            inputType = 'number';
          } else if (tiposValorData.includes(TipoValor)) {
            inputType = 'date';
          }
        }

        textoPlaceholder = `Filtro por ${NomeColuna}`;
      }
    }

    return { inputType, textoPlaceholder };
  }

  const {
    inputType,
    textoPlaceholder
  } = verificaTipoInputEPlaceholder();

  function restaurarOrdenacao() {
    const colunaChave =
      configuracao?.Tipo === TIPO_VISAO.AGRUPAMENTO
        ? obterColunaChave()
        : obterColunaLink();

    if (colunaChave) obterOrdenacaoPadrao(colunaChave);

    let dataFilter = {
      ...dataFilterHeader,
      Filtros: null,
    };
    setDataFilterHeader(dataFilter);
    setFiltro([]);
  }

  function obterNomeColuna(colunaOrdem) {
    const coluna = configuracao?.VisaoColunas?.find(
      c => c?.FonteDados === colunaOrdem
    );

    return coluna?.NomeColuna || colunaOrdem;
  }

  function obterCampoColunaBusca() {
    const colunaBusca =
      configuracao?.Tipo === TIPO_VISAO.AGRUPAMENTO
        ? obterColunaChave()
        : obterColunaLink();

    return colunaBusca?.FonteDados || null;
  }

  const filtrosColunaAtivos = Array.isArray(dataFilterHeader?.Filtros)
    ? dataFilterHeader.Filtros.filter(
        f => f?.Campo && f?.Valor !== null && f?.Valor !== undefined && f?.Valor !== ''
      )
    : [];

  const filtroBuscaAtivo =
    Array.isArray(filtro) &&
    filtro.length > 0 &&
    filtro[0]?.Campo &&
    filtro[0]?.Valor !== null &&
    filtro[0]?.Valor !== undefined &&
    filtro[0]?.Valor !== ''
      ? filtro[0]
      : null;

  // Desduplica filtros por Campo.
  const campoBusca = obterCampoColunaBusca();
  const filtrosAtivosMap = new Map();

  // 1) Primeiro os filtros de coluna (na ordem atual do array)
  filtrosColunaAtivos.forEach(f => {
    if (f?.Campo) filtrosAtivosMap.set(f.Campo, f);
  });

  // 2) Depois o filtro principal (substitui se existir, mas não duplica)
  if (filtroBuscaAtivo?.Campo) {
    filtrosAtivosMap.set(filtroBuscaAtivo.Campo, filtroBuscaAtivo);
  }

  const indiceColunaPorCampo = new Map(
    (configuracao?.VisaoColunas || [])
      .filter(c => !c?.OcultoGridPortal)
      .map((c, idx) => [c?.FonteDados, idx])
  );

  // Ordena para refletir a ordem das colunas na grid (melhor UX).
  const filtrosAtivos = Array.from(filtrosAtivosMap.values()).sort((a, b) => {
    const ia = indiceColunaPorCampo.has(a?.Campo)
      ? indiceColunaPorCampo.get(a?.Campo)
      : 9999;
    const ib = indiceColunaPorCampo.has(b?.Campo)
      ? indiceColunaPorCampo.get(b?.Campo)
      : 9999;
    return ia - ib;
  });

  function removerFiltro(campo) {
    if (!campo) return;

    // Remove do filtro principal (input)
    if (campoBusca && campo === campoBusca) {
      setFiltro([]);
    }

    // Remove do filtro por coluna (filter dropdown)
    setDataFilterHeader(prev => {
      const prevFiltros = Array.isArray(prev?.Filtros) ? prev.Filtros : [];
      const nextFiltros = prevFiltros.filter(f => f?.Campo !== campo);
      return { ...(prev || {}), Filtros: nextFiltros };
    });

    if (pagina !== 1) setPagina(1);
  }

  function limparTodosFiltros() {
    setFiltro([]);
    setDataFilterHeader(prev => ({ ...(prev || {}), Filtros: [] }));
    if (pagina !== 1) setPagina(1);
  }

  const popoverFiltrosContent = (
    <S.PopoverContent>
      {filtrosAtivos.length ? (
        <S.PopoverLista>
          {filtrosAtivos.map((item, idx) => {
            const valor = item?.Valor ?? '';
            const nomeColuna = obterNomeColuna(item?.Campo);

            return (
              <S.PopoverItem key={`${item?.Campo}-${idx}`}>
                <S.PopoverItemIndice>{idx + 1}.</S.PopoverItemIndice>
                <S.PopoverItemConteudo>
                  <Text strong>{nomeColuna}</Text>
                  <Tooltip title={String(valor)}>
                    <Text type="secondary">
                      <S.PopoverItemValor>{String(valor)}</S.PopoverItemValor>
                    </Text>
                  </Tooltip>
                </S.PopoverItemConteudo>

                <S.PopoverItemAcoes>
                  <Tooltip title="Remover este filtro">
                    <Button
                      type="text"
                      danger
                      aria-label={`Remover filtro de "${nomeColuna}"`}
                      icon={<Icons.CloseOutlined />}
                      onClick={() => removerFiltro(item?.Campo)}
                    />
                  </Tooltip>
                </S.PopoverItemAcoes>
              </S.PopoverItem>
            );
          })}

          <S.PopoverFooter>
            <Link onClick={limparTodosFiltros}>Limpar todos os filtros</Link>
          </S.PopoverFooter>
        </S.PopoverLista>
      ) : (
        <S.PopoverEmpty>
          <Text type="secondary">Nenhum filtro aplicado.</Text>
        </S.PopoverEmpty>
      )}
    </S.PopoverContent>
  );

  const ordenacoesAtivas = (listaColunaOrdem || [])
    .filter(o => o?.ColunaOrdem && o?.TipoOrdem)
    .slice()
    .sort((a, b) => (a?.Ordem ?? 9999) - (b?.Ordem ?? 9999));

  const popoverOrdenacaoContent = (
    <S.PopoverContent>
      {ordenacoesAtivas.length ? (
        <S.PopoverLista>
          {ordenacoesAtivas.map((item, idx) => {
            const isAsc = item.TipoOrdem === 'ascend';
            const labelOrdem = isAsc ? 'Crescente' : 'Decrescente';
            const Icone = isAsc
              ? Icons.SortAscendingOutlined
              : Icons.SortDescendingOutlined;

            return (
              <S.PopoverItem
                key={`${item.ColunaOrdem}-${item.TipoOrdem}-${item.Ordem ?? idx}`}
              >
                <S.PopoverItemIndice>{idx + 1}.</S.PopoverItemIndice>
                <S.PopoverItemConteudo>
                  <Text strong>{obterNomeColuna(item.ColunaOrdem)}</Text>
                  <Text type="secondary">
                    <S.OrdenacaoItemLabel>
                      <S.OrdenacaoItemIconeWrap>
                        <Icone />
                      </S.OrdenacaoItemIconeWrap>
                      <span>{labelOrdem}</span>
                    </S.OrdenacaoItemLabel>
                  </Text>
                </S.PopoverItemConteudo>
                <S.PopoverItemAcoes>
                  <Tooltip title="Remover desta ordenação">
                    <Button
                      type="text"
                      danger
                      aria-label={`Remover "${obterNomeColuna(
                        item.ColunaOrdem
                      )}" da ordenação`}
                      icon={<Icons.CloseOutlined />}
                      onClick={() => removerColunaOrdenacao?.(item.ColunaOrdem)}
                    />
                  </Tooltip>
                </S.PopoverItemAcoes>
              </S.PopoverItem>
            );
          })}

          <S.PopoverFooter>
            <Link onClick={restaurarOrdenacao}>Restaurar ordenação padrão</Link>
          </S.PopoverFooter>
        </S.PopoverLista>
      ) : (
        <S.PopoverEmpty>
          <Text type="secondary">
            Nenhuma ordenação aplicada no momento.
          </Text>
          <Link onClick={restaurarOrdenacao}>Restaurar ordenação padrão</Link>
        </S.PopoverEmpty>
      )}
    </S.PopoverContent>
  );

  return (
    <S.RowPrincipal gutter={[16, 16]}>
      {EXIBIR_FILTRO_SIMPLES_ACIMA_GRID && (
        <S.ColFiltroSimples lg={6}>
          <S.SelectField>
            <S.SelectLabel htmlFor="filtro-grid-simples">
              Filtro
            </S.SelectLabel>
            <Input
              id="filtro-grid-simples"
              placeholder={textoPlaceholder}
              aria-label="Filtro"
              maxLength={50}
              value={filtro?.length > 0 ? filtro[0]?.Valor : ''}
              type={inputType}
              onChange={event => {
                if (pagina !== 1) setPagina(1);

                const { FonteDados, TipoValor } =
                  configuracao.Tipo === TIPO_VISAO.AGRUPAMENTO
                    ? obterColunaChave()
                    : obterColunaLink();

                setFiltro([
                  {
                    Campo: FonteDados,
                    Valor: event.target.value,
                    TipoValor,
                  },
                ]);
              }}
              disabled={InputCarregando}
            />
          </S.SelectField>
        </S.ColFiltroSimples>
      )}

      {isFiltroAvancadoHabilitado &&
        configuracao?.Tipo === TIPO_VISAO.ANALITICO && (
          <S.ColBuscaAvancada lg={3}>
            <Tooltip title="Busca Avançada">
              <Button
                type="primary"
                icon={<Icons.FilterOutlined />}
                onClick={() => {
                  history.push({ pathname: `${configuracao.Uri}/busca` });
                }}
              >
                Busca Avançada
              </Button>
            </Tooltip>
          </S.ColBuscaAvancada>
        )}

      {/* Periodicidade/Período/Exercício: agora ficam à esquerda */}
      {periodicidadeSelecionada && (
        <S.WrapperPeriodicidadeMobile>
          {/* xs/sm: empilhados; md/lg (até 1199px): 3 lado a lado com largura total (8+8+8=24); xl (1200px+): desktop com botões (3+3+3=9) */}
          <Col xs={24} sm={24} md={8} lg={8} xl={3}>
            <S.SelectField>
              <S.SelectLabel htmlFor="filtro-grid-periodicidade">
                Periodicidade
              </S.SelectLabel>
              <select
                id="filtro-grid-periodicidade"
                value={periodicidadeSelecionada || 'MENSAL'}
                disabled={listaPeriodicidades?.length === 1}
                onChange={event => {
                  setPeriocidadeSelecionada(event.target.value);
                  setPagina(1);
                }}
                style={nativeSelectStyle}
                title={
                  listaPeriodicidades?.length === 1
                    ? 'Única periodicidade disponível'
                    : 'Periodicidade'
                }
              >
                {(listaPeriodicidades || []).map(value => (
                  <option key={value.Id} value={value.Id}>
                    {value.Descricao}
                  </option>
                ))}
              </select>
            </S.SelectField>
          </Col>

          {!periodoDesabilitado && (
            <Col xs={24} sm={24} md={8} lg={8} xl={3}>
              <S.SelectField>
                <S.SelectLabel htmlFor="filtro-grid-periodo">
                  Período
                </S.SelectLabel>
                <select
                  id="filtro-grid-periodo"
                  disabled={listaPeriodos?.length === 1}
                  value={
                    (periodoSelecionado && periodoSelecionado.toUpperCase()) ||
                    ''
                  }
                  onChange={event => {
                    setPeriodoSelecionado(event.target.value);
                    setPagina(1);
                  }}
                  style={nativeSelectStyle}
                  title={
                    listaPeriodos?.length === 1
                      ? 'Único período disponível'
                      : 'Período'
                  }
                >
                  {(listaPeriodos || []).map(p => (
                    <option key={p.Id} value={p.Id}>
                      {p.Descricao}
                    </option>
                  ))}
                </select>
              </S.SelectField>
            </Col>
          )}

          <Col xs={24} sm={24} md={8} lg={8} xl={3}>
            <S.SelectField>
              <S.SelectLabel htmlFor="filtro-grid-exercicio">
                Exercício
              </S.SelectLabel>
              <select
                id="filtro-grid-exercicio"
                value={exercicioSelecionado ?? obterAnoAtual()}
                disabled={listaExercicios?.length === 1}
                onChange={event =>
                  setExercicioSelecionado(Number(event.target.value))
                }
                style={nativeSelectStyle}
                title={
                  listaExercicios?.length === 1
                    ? 'Único exercício disponível'
                    : 'Exercício'
                }
              >
                {(listaExercicios || []).map(exerc => (
                  <option key={exerc.Exercicio} value={exerc.Exercicio}>
                    {exerc.Exercicio}
                  </option>
                ))}
              </select>
            </S.SelectField>
          </Col>
        </S.WrapperPeriodicidadeMobile>
      )}

      {/* Spacer e botões: apenas em desktop (mobile usa MobileGridFiltrosOrdenacao) */}
      {isDesktop && (
        <>
          <Col flex="auto" />
          {configuracao?.Tipo === TIPO_VISAO.AGRUPAMENTO ||
          configuracao?.Tipo === TIPO_VISAO.ANALITICO ? (
            <S.ColBotoesGrid>
              <S.BotoesGridWrap>
                <Popover
                  content={popoverFiltrosContent}
                  trigger="hover"
                  placement="bottomLeft"
                >
                  <Tooltip title="Ver filtros ativos">
                    <S.BotaoGridWrap as="span">
                      <Button
                        type="default"
                        icon={
                          <S.BotaoGridIcone>
                            <Icons.FilterOutlined aria-hidden />
                          </S.BotaoGridIcone>
                        }
                      >
                        Filtros da grid
                      </Button>
                    </S.BotaoGridWrap>
                  </Tooltip>
                </Popover>

                <Popover
                  content={popoverOrdenacaoContent}
                  trigger="hover"
                  placement="bottomLeft"
                >
                  <Tooltip title="Ver ordenação atual">
                    <S.BotaoGridWrap as="span">
                      <Button
                        type="default"
                        icon={
                          <S.BotaoGridIcone>
                            <Icons.OrderedListOutlined aria-hidden />
                          </S.BotaoGridIcone>
                        }
                      >
                        Ordenação da grid
                      </Button>
                    </S.BotaoGridWrap>
                  </Tooltip>
                </Popover>
              </S.BotoesGridWrap>
            </S.ColBotoesGrid>
          ) : (
            <Col lg={3} />
          )}
        </>
      )}
    </S.RowPrincipal>
  );
}

export default FiltroPeriodicidadeModuloDinamico;
